/**
 * Editor.js Tune for duplicating a block.
 */
export default class DuplicateTune {
    static get isTune() {
        return true;
    }

    constructor({ api }) {
        this.api = api;
        this.button = null;
    }

    /**
     * 깊은 복사를 위한 헬퍼 함수
     * columns 블록의 중첩된 EditorJS 데이터를 안전하게 복제
     */
    deepCloneBlockData(data, tool) {
        // columns 블록인 경우 특별 처리
        if (tool === 'columns' && data.cols) {
            return {
                ...data,
                cols: data.cols.map(col => ({
                    blocks: col.blocks ? col.blocks.map(block => ({
                        ...block,
                        // 각 중첩 블록에 새로운 고유 ID 생성
                        id: this.generateUniqueId(),
                        // 데이터도 깊은 복사
                        data: JSON.parse(JSON.stringify(block.data))
                    })) : []
                })),
                // 나머지 속성들도 깊은 복사
                gap: data.gap,
                ratios: data.ratios ? [...data.ratios] : [],
                style: data.style ? {...data.style} : {}
            };
        }

        // 일반 블록은 JSON 방식으로 깊은 복사
        try {
            return JSON.parse(JSON.stringify(data));
        } catch (e) {
            console.error('깊은 복사 실패:', e);
            return data; // 실패 시 원본 반환 (fallback)
        }
    }

    /**
     * 고유 ID 생성 함수
     */
    generateUniqueId() {
        return Math.random().toString(36).substr(2, 10);
    }

    render() {
        return [
            {
                icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>`,
                title: "블록 복제하기",
                onActivate: () => {
                    this.duplicateBlock();
                    this.api.toolbar.close();
                }
            },
            {type: "separator"}
        ]
    }

    /**
     * 현재 블록을 복제하는 핵심 로직 (insertMany 사용)
     */
    async duplicateBlock() {
        try {
            const currentIndex = this.api.blocks.getCurrentBlockIndex();
            if (currentIndex === -1) return;

            const currentBlock = this.api.blocks.getBlockByIndex(currentIndex);
            const currentBlockData = await currentBlock.save();

            // 깊은 복사를 통해 완전히 독립적인 데이터 생성
            const clonedData = this.deepCloneBlockData(currentBlockData.data, currentBlockData.tool);

            const newBlock = this.api.blocks.insert(
                currentBlockData.tool,
                clonedData,  // 깊은 복사된 데이터 사용
                {}, // config는 비워둡니다.
                currentIndex + 1,
                false // 포커스는 수동으로 제어합니다.
            );

            setTimeout( async() => {
                try {
                    if (currentBlockData.tunes && Object.keys(currentBlockData.tunes).length > 0) {
                        await this.api.blocks.update(newBlock.id, undefined, currentBlockData.tunes);
                    }
                } catch (updateError) {
                    this.api.notifier.show({
                        message: '블록 복제 중 블록스타일 적용 실패.',
                        style: 'error',
                    });
                }

                this.api.caret.setToBlock(newBlock, 'end');
            }, 100);

            this.api.notifier.show({
                message: '블록이 복제되었습니다.',
                style: 'success',
            });

        } catch (error) {
            console.error('블록 복제 중 오류 발생:', error);
            this.api.notifier.show({
                message: '블록 복제에 실패했습니다.',
                style: 'error',
            });
        }
    }
}